const contentSearchList = () => import("./views/contenSearchtList.vue");

export default {
	// 内容搜索
  path: "/contentSearchList",
  name: "contentSearchList",
  component: contentSearchList,
  meta: {
    root: "/inforMan"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/contentSearch/router.js